import axios from 'axios'
import { getBackendUrl } from './general'


export const dataGridVendedores = async (context, page, search) => {
  try {
    let pagePath = page ? `page=${page}` : ''
    let searchPath = search ? pagePath ? `&search=${search}` : `search=${search}` : ''
    let path = pagePath || searchPath ? `&${pagePath}${searchPath}` : ''
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/dataGridVendedores/?tipo=Vendedores${path}`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )
    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataGridDependencias = async (context, idDirectory, page, search) => {
  try {
    let pagePath = page ? `page=${page}` : ''
    let searchPath = search ? pagePath ? `&search=${search}` : `search=${search}` : ''
    let path = pagePath || searchPath ? `?${pagePath}${searchPath}` : ''

    await context.$store.dispatch('statusLogin', context.$router)

    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/directorio/${idDirectory}/dataGridDependencias/${path}`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )

    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataGridDependenciasUsuario = async (context, idUser) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)

    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/archivo/api/usuario/${idUser}/dataGridDependenciasUsuario/`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )

    console.log(res.data);

    return res.data
  } catch (error) {
    console.log(error)
    throw error.response
  }
}

export const dataGridCotizacionesPedidos = async (
  context,
  typeDocument,
  idEmployee,
  idCustomer,
  page,
  search
) => {
  try {
    let paramEmployee = idEmployee ? `&ide=${idEmployee}` : "";
    let paramCustomer = idCustomer ? `&idc=${idCustomer}` : "";
    let paramPage = page ? `page=${page}` : "";
    let paramSearch = search ? page ? `&search=${search}` : `search=${search}` : "";
    let params = paramPage || paramSearch ? `&${paramPage}${paramSearch}` : ""

    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const res = await axios.get(
      `${source}/movimientos/api/dataGridCotizacionesPedidos/?tipo=${typeDocument}${paramEmployee}${paramCustomer}${params}`,
      {
        headers: {
          "Authorization": `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return res.data;
  } catch (err) {
    console.log(err);
    throw err.response;
  }
}

export const dataGridSolicitudesCotizaciones = async (context, idEmployee, page, search) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const parameters = {
      "id": idEmployee,
      "page": page,
      "search": search
    }
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/dataGridSolicitudes/Cotizaciones/`,
      {
        params: parameters,
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return res.data;
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataGridSolicitudesPedidos = async (
  context,
  idEmployee,
  page,
  search
) => {
  try {
    let employeePath = context.$store.state.user.data.tipo_Empleado === 'V' ? `id=${idEmployee}` : ''
    let pagePath = page ? `page=${page}` : ''
    let searchPath = search ? pagePath ? `&search=${search}` : `search=${search}` : ''
    let path = pagePath || searchPath ? `&${pagePath}${searchPath}` : ''
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/dataGridSolicitudes/Pedidos/?${employeePath}${path}`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )

    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataGridMovimientosPedido = async (context, idOrder) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/movimientos/api/dataGridMovimientosPedidos/?id=${idOrder}`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )

    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataGridDocumentos = async (context, page, search, idDirectory, supportDocument) => {
  try {
    const endPoint = "/movimientos/api/documentos/gastosgenerales/";
    const parameters = {
      "page": page,
      "search": search,
      "dirid": idDirectory,
      "docsoporte": supportDocument
    }
    const paramsHeader = {
      "Authorization": `Bearer ${context.$store.state.user.token}`
    };

    // parameters.id = 1977;

    console.log(parameters);
    

    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const urlService = `${source}${endPoint}`;

    const res = await axios.get(
      urlService,
      {
        params: parameters,
        headers: paramsHeader
      }
    );

    return res.data;
  } catch (err) {
    throw err.response;
  }
}

export const dataDocumentoMovimientosKardex = async (context, idDocument) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl();
    const res = await axios.post(
      `${source}/consultas/api/dataDocumentoMovimientosKardex`,
      {
        Id_Documento: idDocument
      },
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return res.data;
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataGridDocumentosAnexos = async (context, typeQuery, id) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/movimientos/api/dataGridDocumentosAnexos/${typeQuery}/${id}/`,
      {
        headers: {
          "Authorization": `Bearer ${context.$store.state.user.token}`
        }
      }
    )

    return res.data
  } catch (err) {
    console.log(err);
    throw err.response
  }
}

export const dataGridSerialesDocumento = async (context, idDocument) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/movimientos/api/dataGridSerialesDocumento/?id=${idDocument}`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )

    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataGridSerialesProducto = async (context, idProduct, page, search) => {
  try {
    let pagePath = page ? `page=${page}` : ''
    let searchPath = search ? pagePath ? `&search=${search}` : `search=${search}` : ''
    let path = pagePath || searchPath ? `&${pagePath}${searchPath}` : ''
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/movimientos/api/dataGridSerialesProducto/?id=${idProduct}${path}`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )

    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}

export const dataGridCompras = async (context, page, search, idDirectory) => {
  try {
    const endPoint = "/movimientos/api/documentos/facturascompra/";
    const parameters = {
      "page": page,
      "search": search,
      "dirid": idDirectory
    };
    const paramsHeader = {
      "Authorization": `Bearer ${context.$store.state.user.token}`
    };

    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const urlService = `${source}${endPoint}`;

    const res = await axios.get(
      urlService,
      {
        params: parameters,
        headers: paramsHeader
      }
    );

    return res.data;
  } catch (err) {
    throw err.response;
  }
}

export const dataGridDocumentosElectronicos = async (context, firstDate, lastDate, typeDocument, page) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const res = await axios.post(
      `${source}/consultas/api/dataGridDocumentosElectronicos`,
      {
        Fecha_Inicial: firstDate,
        Fecha_Final: lastDate,
        Tipo_Documento: typeDocument,
        Pagina: page
      },
      {
        headers: {
          "Authorization": `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return res.data;
  } catch (err) {
    console.log(err);
    throw err.response;
  }
}

export const dataGridSeguimientos = async (context, filters, page, search) => {
  const parameters = {
    ...filters,
    "page": page,
    "search": search
  };
  const paramsHeader = {
    "Authorization": `Bearer ${context.$store.state.user.token}`
  };
    
  try {
    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const res = await axios.get(
      `${source}/mercadeo/api/dataGridSeguimientos/`,
      {
        params: parameters,
        headers: paramsHeader
      }
    );

    return res.data;
  } catch (err) {
    console.log(err);
    throw err.response;
  }
}

export const dataGridCalendario = async (context, idEmployee, typeCalendar) => {
  const parameters = {
    "ID": idEmployee,
    "type": typeCalendar
  }

  try {
    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const endPoint = "/mercadeo/api/dataGridCalendario/";
    const urlService = `${source}${endPoint}`;
    const paramsHeader = {
      "Authorization": `Bearer ${context.$store.state.user.token}`
    };
    const response = await axios.get(
      urlService,
      {
        params: parameters,
        headers: paramsHeader
      }
    );

    return response.data;
  } catch (err) {
    // console.log(err);
    throw err.response;
  }
}
